import { render, staticRenderFns } from "./ExcLoader.vue?vue&type=template&id=c2874098&scoped=true&"
import script from "./ExcLoader.vue?vue&type=script&lang=ts&"
export * from "./ExcLoader.vue?vue&type=script&lang=ts&"
import style0 from "./ExcLoader.vue?vue&type=style&index=0&id=c2874098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2874098",
  null
  
)

export default component.exports